import { IconButton, LogOutLineIcon } from "@relex-solutions/fragments"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router"
import styles from "./LogoutButton.module.css"

export function LogoutButton() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  return (
    <IconButton
      onClick={() => {
        void navigate("/logout")
      }}
      variant="outline"
      color="--var(--fr-white)"
      aria-label={t("header.logout")}
      tooltip={t("header.logout")}
      className={styles.logoutButton}
    >
      <LogOutLineIcon className={styles.logoutIcon} />
    </IconButton>
  )
}
